module.exports = __webpack_public_path__ + "static/media/university.ef759228.svg";